import React, {FC} from "react";
import {useUserRole} from "./auth/redux/auth.hook";
import {Redirect} from "react-router-dom";

export const AppSlashRedirect: FC = () => {

    const role = useUserRole();

    return (
        role ? <Redirect to={role === "admin" ? "/admin/calendar" : "/worker"}/> : <Redirect to={"/login"}/>
    )
}
